import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReportsService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listReports(filters = "") {
    return this.http.get(this.api+`/equipamento${filters}`);
  }
}
